import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import './index.css';
import App from './App.js';
import ErrorPage from "./pages/ErrorPage"
import Home from "./pages/Home";
import Listen from "./pages/Listen";
import Signup from "./pages/Signup";
import Login from './pages/Login';
import Profile from './pages/Profile';
import {ChakraProvider} from "@chakra-ui/react";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                element: <Home />,
            },
            {
                path: "listen",
                element: <Listen />,
            },
            {
                path: "profile",
                element: <Profile />,
            },
        ],
    },
    {
        path: "/login",
        element:
            <ChakraProvider>
                <div className="App" style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: '100%'}}>
                    <Login />
                </div>
            </ChakraProvider>,
    },
    {
        path: "/signup",
        element:
            <ChakraProvider>
                <div className="App" style={{display: "flex", flexDirection: "column", justifyContent: "space-between", height: '100%'}}>
                    <Signup />
                </div>
            </ChakraProvider>,
    },
    {
        path: "/ping",
        element: <span>pong</span>,
    },
])

root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
